module.exports = __webpack_public_path__ + "img/download.34304e76.png";